import Container from "@/components/Container/Container.tsx";
import Modal from "@/components/Modal/Modal.tsx";

import { ReservationSidebar } from "@/components/ReservationSidebar/ReservationSidebar.tsx";
import { Stepper } from "@/components/Stepper/Stepper.tsx";
import { useScrollToTop } from "@/helpers/scrollToTop.ts";
import { useCartDrawerState } from "@/helpers/useCartDrawerState.ts";
import { RPCancelationPolicyModalDetailed } from "@/pages/AccommodationPicking/components/RPCancelationPolicyModalDetailed/RPCancelationPolicyModalDetailed.tsx";
import { ExtraOptionsAccommodationBlock } from "@/pages/ExtraOptions/components/ExtraOptionsAccommodationBlock.tsx";

import { useValidateExtraOptionsStep } from "@/pages/ExtraOptions/hooks/useValidateExtraOptionsStep.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { AppPage } from "@/stores/EngineStore/enums/AppPage.ts";
import { ModalKey } from "@/stores/ModalStore/ModalKey.ts";
import { useModalStore } from "@/stores/ModalStore/useModalStore.ts";
import { useTranslation } from "react-i18next";
import { useShallow } from "zustand/react/shallow";

export const ExtraOptions = () => {
  const { t } = useTranslation();
  const scrollToTop = useScrollToTop();
  const { handleCloseCartDrawer } = useCartDrawerState();
  const { setPage, cartAccommodationItems } = useEngineStore(
    useShallow((state) => ({
      setPage: state.setPage,
      cartAccommodationItems: state.cartAccommodationItems,
    })),
  );
  const { open, closeModal, key } = useModalStore(
    useShallow((state) => ({ open: state.open, closeModal: state.closeModal, key: state.key })),
  );
  const { areParcelVehicleDimensionsMissing, areChildAgesMissing, isCaravanMoverMissing } =
    useValidateExtraOptionsStep();

  return (
    <div>
      <Stepper
        disableNext={areParcelVehicleDimensionsMissing || areChildAgesMissing || isCaravanMoverMissing}
      />
      <main className="extrasWrap o-page">
        <div className="o-page__inner">
          <section className="c-extras-wrapper">
            <Container>
              <div className="c-extras">
                <div className="c-extras__accommodations-list">
                  {cartAccommodationItems?.map((item) => (
                    <ExtraOptionsAccommodationBlock key={item.id} item={item} />
                  ))}
                </div>
                <div className="extrasSummary c-extras__summary">
                  <div className="c-extras__summary-inner">
                    <ReservationSidebar
                      hideRemoveRate
                      continueBtnPopoverText={
                        areChildAgesMissing
                          ? t("childAgeMissing")
                          : areParcelVehicleDimensionsMissing
                          ? t("parcelVehicleDimensionsMissing")
                          : isCaravanMoverMissing
                          ? t("caravanMoverMissing")
                          : undefined
                      }
                      continueDisabled={
                        areParcelVehicleDimensionsMissing || areChildAgesMissing || isCaravanMoverMissing
                      }
                      onContinue={() => {
                        setPage(AppPage.HolderAndPaymentInfo);
                        handleCloseCartDrawer();
                        scrollToTop();
                      }}
                    />
                  </div>
                </div>
              </div>
            </Container>
          </section>
        </div>
      </main>
      <Modal isOpen={open && key === ModalKey.RPCancelationPolicy} onClose={closeModal}>
        <RPCancelationPolicyModalDetailed />
      </Modal>
    </div>
  );
};
